import React from 'react';
import { Link } from 'react-router-dom';
import { A8Banner234x60 } from '../components/A8Ads';

const ColumnsPage: React.FC = () => {
  return (
    <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">📰 投資コラム</h2>
        <Link to="/" className="btn-secondary text-sm">← ホームへ</Link>
      </div>

      <div className="card">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">長期投資と複利の力</h3>
        <p className="text-gray-700 text-sm leading-6">
          長期での資産形成では、時間を味方にした複利効果が重要です。積立とマーケットの成長が相互に作用します。
        </p>
      </div>

      <div className="card">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">リスクとリターンのバランス</h3>
        <p className="text-gray-700 text-sm leading-6">
          期待リターンとボラティリティのトレードオフを理解し、自分の許容範囲に合わせて配分を決めましょう。
        </p>
      </div>

      <div className="card">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">取り崩し戦略と安全域</h3>
        <p className="text-gray-700 text-sm leading-6">
          取り崩しは定額・定率など方式により破綻確率や資産寿命が変わります。安全域を持った設計が肝要です。
        </p>
      </div>

      {/* ページ下部にPR枠を1つだけ表示（同意後のトップと重複しにくい） */}
      <div className="card">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">PR</h3>
        <div className="flex flex-wrap gap-3 items-center">
          <A8Banner234x60 />
        </div>
      </div>
    </main>
  );
};

export default ColumnsPage;
